var map = {
	"./customer-bg.webp": 1565,
	"./customer-img.webp": 1566,
	"./games-img.webp": 1567,
	"./lc-img.webp": 1568,
	"./lottery-img.webp": 1569,
	"./mission-bg.webp": 1570,
	"./mission-img.webp": 1571,
	"./mobile-bg.webp": 1572,
	"./p2p-img.webp": 1573,
	"./product-bg.webp": 1574,
	"./sb-provider.webp": 1575,
	"./sbo-provider.webp": 1576,
	"./sideBar-bg.webp": 1577,
	"./slot-img.webp": 1578,
	"./spade-img.webp": 1579,
	"./sport-img.webp": 1580
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 208;